import { render, staticRenderFns } from "./ABTestRenameModal.vue?vue&type=template&id=d0ac9452&"
import script from "./ABTestRenameModal.vue?vue&type=script&lang=ts&"
export * from "./ABTestRenameModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports